import { PinInput as e } from "@ark-ui/react";
import t, { forwardRef as y } from "react";
import { cx as x, css as C } from "@huspy/styled-system/css";
import { splitCssProps as b } from "@huspy/styled-system/jsx";
import { pinInput as i } from "@huspy/styled-system/recipes";
import { InputLabel as v, Input as w, InputDescription as R } from "../input/input.mjs";
import "../input/input-group.mjs";
const k = y((m, c) => {
  const [u, d] = i.splitVariantProps(m), [s, I] = b(d), {
    children: a,
    className: P,
    invalid: o,
    full: f,
    length: E = 4,
    placeholder: h = "",
    description: l,
    ...N
  } = I, r = i(u);
  return /* @__PURE__ */ t.createElement(
    e.Root,
    {
      className: x(r.root, C(s), P),
      ref: c,
      invalid: o,
      placeholder: h,
      ...N
    },
    a && /* @__PURE__ */ t.createElement(e.Label, { className: r.label, asChild: !0 }, /* @__PURE__ */ t.createElement(v, null, a)),
    /* @__PURE__ */ t.createElement(e.Control, { className: r.control }, Array.from({ length: E }, (p, n) => n).map((p, n) => /* @__PURE__ */ t.createElement(e.Input, { className: r.input, key: p, index: n, asChild: !0 }, /* @__PURE__ */ t.createElement(
      w,
      {
        width: f ? "100%" : void 0,
        type: s.mask ? "password" : "text",
        size: "xl",
        isError: o
      }
    )))),
    l && /* @__PURE__ */ t.createElement(R, { isError: o }, l),
    /* @__PURE__ */ t.createElement(e.HiddenInput, null)
  );
});
k.displayName = "PinInput";
export {
  k as PinInput
};
